import React from "react"
// @ts-ignore
import PillPriority from "../../../../../gd-components/molecules/pill/pill-priority";

export default function PriorityMultiselectValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-field-form-editable dropdown-form fl-wrap min-h-36", props.className)} onClick={props.onClick}>
                {_.map(props.options, option => {

                    return <PillPriority size       = {26}
                                 value      = {option}
                                 onClick    = {props.onClick}
                                 onDelete   = {props.onDelete}
                                 priority   = {option.value}
                                 className  = "m-r-10 m-t-4 m-b-4"
                                 style      = {props.style}
                                 key        = {option.value}
                    />

                })}
            </div>
            {props.children}
        </React.Fragment>
    )
}